import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../common/hooks/useI18n'
import useViewport from '../../../../common/hooks/useViewport'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Loading } from '../../../../common/loading'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { Table } from '../../../../common/table'
import { getUnique } from '../../../../helpers/common'
import { UseScoreRange } from '../../common/hooks/useScoreRange'
import {
  COLUMN_ID_TABLE,
  ITEM_ANY_POTENTIAL,
  ITEM_ANY_RISK,
  TITLE_TABLE_CHANGE_SCORE_TREND,
  TREND_SCORE,
  VALUE_SCORE,
} from '../../constant'
import {
  addItemTableChange,
  changeFragment,
  getDataTableChange,
  getDataTableChangeRedux,
  getLoadingTrend,
  selectIdsTableChange,
} from '../store/slice'
import { getTrendConfig, postTrendConfig } from '../store/thunk'
import { ActionDelete } from './schemaTable/ActionDelete'
import { LevelSelect } from './schemaTable/LevelSelect'
import { TrendSelect } from './schemaTable/TrendSelect'

export const PopupScoreTrend = ({
  isShow,
  onClose,
  title,
  isDynamic,
  typeValue,
}) => {
  const dispatch = useDispatch()
  const { height } = useViewport()

  const ids = useSelector(selectIdsTableChange)
  const isLoading = useSelector(getLoadingTrend)
  const dataTable = useSelector(getDataTableChange)

  const { data: dataRangeScore, loading } = UseScoreRange(
    isDynamic ? false : true,
  )

  const itemAnyByScore = useMemo(
    () =>
      typeValue === VALUE_SCORE.CREDIT_SCORE
        ? ITEM_ANY_RISK
        : ITEM_ANY_POTENTIAL,
    [typeValue],
  )

  const renderLevelSelect = (value, rowId, colId) => (
    <LevelSelect
      data={value}
      rangeScore={
        typeValue === VALUE_SCORE.CREDIT_SCORE
          ? dataRangeScore?.CREDIT_RISK
          : dataRangeScore?.PERFORMANCE
      }
      rowId={rowId}
      colId={colId}
      itemAnyByScore={itemAnyByScore}
    />
  )

  const schema = TITLE_TABLE_CHANGE_SCORE_TREND.map((item) => {
    const colId = item.key
    const title = UseI18n(item.title)
    return {
      colId,
      title,
      thStyle: item.thStyle,
      tdStyle: item.tdStyle,
      render: (data, { rowId }) => {
        switch (colId) {
          case COLUMN_ID_TABLE.TREND:
            return <TrendSelect data={data} rowId={rowId} colId={colId} />
          case COLUMN_ID_TABLE.PREVIOUS:
            return <>{renderLevelSelect(data, rowId, colId)}</>
          case COLUMN_ID_TABLE.CURRENT:
            return <>{renderLevelSelect(data, rowId, colId)}</>
          case COLUMN_ID_TABLE.ICON_DELETE:
            return <ActionDelete rowId={rowId} />
          default:
            return data
        }
      },
    }
  })

  const onSubmit = () => {
    dispatch(
      postTrendConfig({
        trendConfigs: dataTable,
        modelId: typeValue,
      }),
    )
      .unwrap()
      .then(() => {
        onClose()
        dispatch(changeFragment())
      })
      .catch(() => {})
  }

  const handleAddItem = () => {
    const id = getUnique()
    dispatch(
      addItemTableChange({
        [id]: {
          currentLevel: itemAnyByScore?.scoreRangeId?.toString(),
          id: id,
          previousLevel: typeValue === VALUE_SCORE.CREDIT_SCORE ? '6' : '5',
          trend: TREND_SCORE.UNDEFINED,
        },
      }),
    )
  }

  useEffect(() => {
    dispatch(
      getTrendConfig({
        ModelId: typeValue,
      }),
    )
    if (isDynamic) {
    }
  }, [])

  return (
    <PopupAction
      appendStyle={{
        padding: '20px',
        backgroundColor: '#F3F3F3',
        width: 1000,
        borderRadius: '4px',
      }}
      isShow={isShow}
      title={title}
      btnCancel={{
        label: 'common.CANCEL',
        isI18n: true,
        event: onClose,
      }}
      btnSubmit={{
        label: 'postLogin.SAVE',
        isI18n: true,
        event: onSubmit,
      }}
      handleClose={onClose}
    >
      {isLoading || loading ? (
        <div style={{ height: 200 }}>
          <Loading />
        </div>
      ) : (
        <>
          <div className="pb1 cursorPointer">
            <Element
              className="dFlex alignItemsCenter wFitContent"
              style={{
                backgroundColor: '#2C73E8',
                padding: '2px 12px',
                gap: 4,
                borderRadius: 2,
                color: '#FFFFFF',
              }}
              onClick={handleAddItem}
            >
              <Icon className="icon-plus" style={{ fontSize: 7 }} />
              <Translate value="portfolioScore.add" />
            </Element>
          </div>
          <Table
            ids={ids}
            getDataFromRedux={getDataTableChangeRedux}
            schema={schema}
            autoHeightMax={height * 0.7}
          />
        </>
      )}
    </PopupAction>
  )
}
